import { Schema } from 'rsuite'
import { normalizePhoneNumber } from '@@partner:helpers/util'

const { StringType } = Schema.Types

export const OperatorFormValidationModel = Schema.Model({
  firstName: StringType().isRequired('Поле обязательно для заполнения!'),
  lastName: StringType().isRequired('Поле обязательно для заполнения!'),
  email: StringType().isEmail('Введите корректный e-mail адрес'),
  phone: StringType()
    .isRequired('Поле обязательно для заполнения')
    .addRule((value: string) => {
      const normalized = normalizePhoneNumber(value)
      return normalized.length === 11
    }, 'Некорректно заполнен номер телефона!'),
  password: StringType()
    .minLength(8, 'Минимум 8 символов')
    .containsLetter('Должен содержать буквы')
    .containsNumber('Должен содержать цифры'),
  repeatPassword: StringType().addRule(
    (value, data) => value === data.password,
    'Пароли не совпадают'
  )
})
